import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

function fiftyfifty() {
	var $container = $('.c-fifty-fifty-row_container'),
			desktop    = window.matchMedia('(min-width: 768px)').matches;

	// Bail if not desktop
	if( !desktop ) return;

  $container.each(function() {
    var $image = $(this).find('img');

    if( !$image.length ) return;

    const calloutTl = gsap.timeline({
      scrollTrigger: {
        trigger: $(this),
        top: 'top 120px',
        scrub: true,
      }
    });

    calloutTl.to( $image, {yPercent: -15, ease: 'none',} );
  });
}

export { fiftyfifty };